<template>

    <div class="layout__padding-clear layout__width-70 text__align-center">
        <div class="layout__margin-60-0 layout__overflow-hidden">

            <img class="layout__padding-20-0 layout__width-200px"
                 src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/sawydeHarris/sawdye-ampersand.png">

            <p class="text__colour-white layout__padding-20-0">Design Studio</p>

            <div class="text__size-36 text__colour-white">Sawyde & Harris</div>

            <hr>

            <p class="text__line-height-30px text__colour-white">
                Sawdye & Harris engaged with Ravensworth to produce a full rebrand and accompanying creative collateral.
                We knew it was important that Sawdye & Harris’ traditional roots were retained, and proposed a
                hand-crafted ampersand which complemented the timeless yet modern san serif typeface.
            </p>

            <hr>

            <el-button class="button-red layout__width-200px"
                       v-on:click="showcase()">Back to our work
            </el-button>


            <div class="layout__overflow-hidden layout__margin-40-0">
                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/sawydeHarris/Sawdye-Harris-case-study-.jpg">

                <div class="layout__padding-20-0 text__size-30 text__colour-white">
                    & is a simple word. It implies <span class="text__colour-ee2321">extra</span>. The ampersand is crucial to the new Sawdye & Harris brand. It
                    reflects their commitment to giving their customers <span class="text__colour-ee2321">more</span>.

                </div>

                <p class="text__colour-white layout__padding-20-0">Mission Statement</p>

                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/sawydeHarris/Sawdye-Harris-case-study-3.jpg">

                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/sawydeHarris/Sawdye-Harris-case-study-4.jpg">

                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/sawydeHarris/Sawdye-Harris-case-study-5.jpg">

                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/sawydeHarris/Sawdye-Harris-case-study-6.jpg">
            </div>


        </div>
    </div>

</template>

<script>
    import Router from '../../../router';
    import {Carousel, Slide} from 'vue-carousel';

    export default {
        name: "landnewhomes",
        props: {},
        components: {
            Carousel,
            Slide
        },
        mixins: [],
        data() {
            return {}
        },
        created() {
        },
        methods: {
            contactUs() {
                Router.push({
                    name: '/contact'
                });
            },
            print() {
                Router.push({
                    name: '/products/print'
                });
            },
            digital() {
                Router.push({
                    name: '/products/print'
                });
            },
            showcase(page) {
                Router.push({
                    name: '/services/design-studio/our-work',
                    query: {
                        client: page,
                    }
                });
            }
        },
    };
</script>